import React from 'react';
import ConnectorFormKey from '../Key';

export default function ProcessorKeyBased({ processorSettings, setProcessorSettings, submitted, keyDisabled }) {
    return (
        <ConnectorFormKey
            value={processorSettings.key ?? ''}
            setKey={(v) => setProcessorSettings(prev => ({ ...prev, key: v }))}
            submitted={submitted || keyDisabled}
        />
    );
}
